import { Alert, AlertWithError } from '@/utils/eventBus'
import { EventBusInjectionKey } from '@/utils/injection-keys'
import { inject } from 'vue'

export function useAlert() {
  const eventBus = inject(EventBusInjectionKey)!

  function info(data: Alert) {
    eventBus.emit('alert:info', data)
  }

  function warn(data: Alert) {
    eventBus.emit('alert:warn', data)
  }

  function ok(data: Alert) {
    eventBus.emit('alert:ok', data)
  }

  function error(data: AlertWithError) {
    eventBus.emit('alert:error', data)
  }

  return {
    info,
    warn,
    ok,
    error,
  }
}
